import styled from 'styled-components';

export const LabelTrendContainer = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 9px;
  background-color: ${props =>
    props.trend === 'top' ? props.theme.colors.success80w : props.theme.colors.danger80w};
  padding: 0 10px;
  height: 30px;

  & > svg {
    margin-right: 6px;
  }

  & > label {
    margin: 0;
    font-family: ${props => props.theme.fonts.gtEesti};
    font-size: 16px;
    line-height: 18px;
  }
`;
